const { default: config } = require('@/config/config')

module.exports = {
    donutChartWithSideLegend: {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            orient: 'vertical',
            bottom: 'center',
            right: '10%',
            icon: 'circle'
        },
        grid: {},
        series: [
            {
                name: 'CTA type',
                type: 'pie',
                radius: ['40%', '70%'],
                data: [
                    { value: 1048, name: 'VI' },
                    { value: 735, name: 'Airtel' },
                    { value: 580, name: 'JIO' }
                ],
                center: ['35%', '50%'],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                labelLine: {
                    show: false
                },
                label: {
                    show: false
                },
                color: config.DONUT_CHART_COLORS
            }
        ]
    }
}
